/**
 * Environment Configuration
 * 
 * Centralized configuration for environment variables
 * used throughout the application.
 * 
 * Note: BRAND_ID is now exported from @/brands/brand-utils
 * Import it from there instead of this file for brand-related code.
 */

export const APP_VERSION = import.meta.env.VITE_IMAGE_TAG || 'dev';
// Empty string for local dev = uses Vite proxy (/api/* -> localhost:8080)
// Set VITE_CHAT_API_URL in production to the full backend URL
export const CHAT_API_URL = import.meta.env.VITE_CHAT_API_URL || '';
export { BRAND_ID } from '../brands/brand-utils';
